<template>
	<div class="hint-text" v-if="hint" :class="{ 'error--text': errored }">
		<span v-safe-html="hint"></span>
	</div>
</template>

<script>
export default {
	props: [ 'param', 'errored' ],
	data () {
		return {
			hint: ''
		}
	},
	mounted () {
		this.hint = this.param.help.replace(/\\n/g, '<br>')
	}
}
</script>

<style lang="stylus" scoped>
.hint-text
	color: var(--v-background-lighten4)
	padding-left: 1px
	padding-bottom: 12px
	line-height: 1.1
	margin-top: -6px
</style>



// WEBPACK FOOTER //
// src/components/fields/hint.vue